import { render } from "./RebateTierHistory.vue?vue&type=template&id=4b442bdc&scoped=true"
import script from "./RebateTierHistory.vue?vue&type=script&lang=js"
export * from "./RebateTierHistory.vue?vue&type=script&lang=js"

import "./RebateTierHistory.vue?vue&type=style&index=0&id=4b442bdc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b442bdc"]])

export default __exports__